import React from 'react';
import FormButton from '@app/component/form/button/FormButton';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

const ReviewsAutoReplyButton = React.memo(() => {

	return <FormButton state='white' extraClassName="h-8 text-xs">
		<Cog6ToothIcon className="h-4 w-4 flex-shrink-0 mr-1.5" />
		<span>Auto Reply</span>
	</FormButton>
});

export default ReviewsAutoReplyButton;